import React from "react";
import { Typography } from "@mui/material";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";

const PercentageStat = ({ value }) => {
  return (
    <Typography
      paragraph
      style={{
        marginBottom: 0,
        fontWeight: 500,
        color: value > 0 ? "#4CAF50" : value < 0 ? "#EF5350" : "",
      }}
    >
      {value > 0 && (
        <ArrowUpward fontSize="small" sx={{ verticalAlign: "middle" }} />
      )}

      {value < 0 && (
        <ArrowDownward fontSize="small" sx={{ verticalAlign: "middle" }} />
      )}

      {`${Math.abs(value ?? 0)}%`}
    </Typography>
  );
};

export default PercentageStat;
